import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../assets/EtablissementServices.scss";
import Layout from "./layout";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  fetchEtablissementById,
  setSelectedEtablissement,
} from "../../store/slices/etablissementSlice";
import { useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Checkbox from "../../components/inputs/checkbox";
import LocationAutocomplete from "../../components/LocationAutocomplete";
import { useLoadScript } from "@react-google-maps/api";
import {
  createAdrFacturation,
  fetchReservationById,
} from "../../store/slices/rendezVousSlice";
import { Helmet, HelmetProvider } from "react-helmet-async";
const libraries = ["places"];
const Facturation = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch reservation when component mounts or id changes
    dispatch(fetchReservationById(id));
    // console.log("hereee");
  }, [dispatch, id]);

  const etablissement = useSelector(
    (state) => state.etablissements.selectedEtablissement
  );
  const { selectedPrestations, currentReservation, currentReservationStatus } =
    useSelector((state) => state.rendezvous);
  // console.log(currentReservation);
  useEffect(() => {
    // This will run whenever currentReservationStatus or currentReservation changes
    if (
      currentReservationStatus === "succeeded" &&
      currentReservation?.etablissement_id
    ) {
      dispatch(fetchEtablissementById(currentReservation.etablissement_id));
    }
  }, [currentReservationStatus, currentReservation, dispatch]);
  const { user, adresse_facturation } = useSelector((state) => state?.user);
  let facturationAdresse = adresse_facturation;

  if (!adresse_facturation && currentReservation?.adresse_facturation) {
    facturationAdresse = currentReservation.adresse_facturation;
  }
  const initialValues = {
    street: facturationAdresse?.numero_rue || "",
    addressComplement: facturationAdresse?.complement_adresse || "",
    lat: null,
    lng: null,
    postalCode: facturationAdresse?.code_postal || "",
    city: facturationAdresse?.ville || "",
    useSameAddress: facturationAdresse?.code_postal ? true:false,
  };

  const validationSchema = Yup.object().shape({
    street: Yup.string().required("Numéro et voie est requis"),
    city: Yup.string().required("Ville est requise"),
    postalCode: Yup.string()
      .required("Code postal est requis")
      .matches(/^\d{5}$/, "Le code postal doit contenir 5 chiffres"),
  });

  const onSubmit = async (values) => {
    // console.log("Form submitted:", values);
    const isUnchanged =
      values.street === initialValues.street &&
      values.addressComplement === initialValues.addressComplement &&
      values.city === initialValues.city &&
      values.postalCode === initialValues.postalCode &&
      values.useSameAddress === initialValues.useSameAddress;
    let data;
    if (isUnchanged) {
      // If no changes, navigate directly to payment page
      data = {
        reservation_id: parseInt(id),
        adresse_facturation_id: facturationAdresse?.id,
      };
    } else {
      data = {
        numero_rue: values?.street,
        ville: values?.city,
        code_postal: values?.postalCode,
        reservation_id: parseInt(id),
        is_default: values?.useSameAddress,
        complement_adresse:values?.complement_adresse
      };
    }

    // Handle form submission and navigation
    try {
      // Dispatch the create appointment action
      const resultAction = await dispatch(createAdrFacturation(data));
      // console.log({ resultAction });
      if (createAdrFacturation.fulfilled.match(resultAction)) {
        // Success case
        // localStorage.setItem('resultAction',JSON.stringify(resultAction?.payload?.reservation))
        navigate(`/payment/${id}`);
      } else {
        // Handle error case
        // console.error("Failed to create appointment:", resultAction.payload);
        // alert("Erreur lors de la création du rendez-vous");
      }
    } catch (error) {
      // console.error("Error creating appointment:", error);
      // alert("Une erreur est survenue");
    }
  };

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });
  const handleLocationSelect = (place, setFieldValue, setFieldTouched) => {
    if (!place) {
      setFieldValue("street", "");
      setFieldValue("lat", null);
      setFieldValue("lng", null);
      setFieldValue("postalCode", null);
      setFieldValue("city", null);
    } else {
      setFieldValue("street", place.description);

      if (isLoaded && window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ placeId: place.place_id }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
            const { lat: googleLat, lng: googleLng } =
              results[0].geometry.location;
            let city = "";
            let postalCode = "";

            results[0].address_components.forEach((component) => {
              if (component.types.includes("locality")) {
                city = component.long_name;
              }
              if (component.types.includes("postal_code")) {
                postalCode = component.long_name;
              }
            });

            setFieldValue("lat", googleLat());
            setFieldValue("lng", googleLng());
            setFieldValue("postalCode", postalCode);
            setFieldValue("city", city);
          }
        });
      }
    }
    setFieldTouched("street", true);
  };

  return (
    <>
      {currentReservation && (
        <Layout
          currentStep={3}
          etablissement={etablissement}
          prestation={currentReservation?.prestations_snapshot}
          recap={true}
          from="facturation"
          conf={true}
          btn={false}
        >
             <HelmetProvider>
                            <Helmet>
                              <title>Page adresse de facturation paiement réservation </title>
                              <meta
                                name="description"
                                content="adresse de facturation paiement réservation "
                              />
                            </Helmet>
                          </HelmetProvider>
          <div className="max-w-md mx-auto p-6 bg-white rounded-lg shadow-md">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                touched,
                errors,
                values,
                setFieldValue,
                setFieldTouched,
              }) => (
                <Form>
                  <h2 className="text-xl font-bold ">Adresse de facturation</h2>
                  {/* Company Address Field */}
                  <div className="input-wrapper mt-8">
                    <label className="form-label">Numéro et voie*</label>
                    <div className="relative">
                      <LocationAutocomplete
                        onLocationSelect={(place) =>
                          handleLocationSelect(
                            place,
                            setFieldValue,
                            setFieldTouched
                          )
                        }
                        isGoogleLoaded={isLoaded}
                        value={values.street}
                      />
                    </div>

                    <ErrorMessage name="street">
                      {(msg) => (
                        <div className="error-message mt-1">
                          <img
                            src="/images/alert-circle.svg"
                            className="arrow mr-8"
                            alt="Arrow"
                          />
                          {msg}
                        </div>
                      )}
                    </ErrorMessage>
                  </div>

                  {/* Address Complement */}
                  <div className="input-wrapper mt-24">
                    <label className="form-label">Complément d'adresse</label>
                    <Field
                      name="addressComplement"
                      className="w-full p-3 border border-gray-300 rounded"
                      placeholder="Résidence G"
                      value={values?.complement_adresse}
                    />
                  </div>

                  {/* City and Postal Code */}
                  <div className="row mt-24">
                    {/* City Field */}
                    <div className="col-md-6 input-wrapper">
                      <label className="form-label block text-sm font-medium text-gray-700 mb-1">
                        Ville*
                      </label>
                      <Field
                        name="city"
                        // readOnly={!!values.city}
                        className={`w-full p-3 border rounded ${
                          touched.city && errors.city
                            ? "is-invalid border-red-500"
                            : "border-gray-300"
                        } ${values.city ? "bg-gray-100" : ""}`}
                      />
                      <ErrorMessage name="city">
                        {(msg) => (
                          <div className="error-message mt-1 text-red-500 text-sm">
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>

                    {/* Postal Code Field */}
                    <div className="col-md-6 input-wrapper">
                      <label className="form-label block text-sm font-medium text-gray-700 mb-1">
                        Code postal*
                      </label>
                      <Field
                        name="postalCode"
                        // readOnly={!!values.postalCode}
                        className={`w-full p-3 border rounded ${
                          touched.postalCode && errors.postalCode
                            ? "is-invalid border-red-500"
                            : "border-gray-300"
                        } ${values.postalCode ? "bg-gray-100" : ""}`}
                        placeholder="00000"
                      />
                      <ErrorMessage name="postalCode">
                        {(msg) => (
                          <div className="error-message mt-1 text-red-500 text-sm">
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </div>
                  </div>

                  {/* Same Address Checkbox */}
                  <div className="input-wrapper mt-24">
                    <label className="flex items-center">
                      <Checkbox
                        id="useSameAddress"
                        label="Enregistrer l’adresse de facturation"
                        checked={values.useSameAddress}
                        onChange={(e) =>
                          setFieldValue("useSameAddress", e.target.checked)
                        }
                      />
                    </label>
                  </div>

                  {/* Submit Button */}
                  <button type="submit" className="twyny-cta-primary w-100">
                    Confirmer
                  </button>
                </Form>
              )}
            </Formik>
          </div>
        </Layout>
      )}
    </>
  );
};

export default Facturation;
